import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { UNSAVED_CHANGES } from "@/constants/testIds";

// Fase 3 — modal único, com texto exato exigido, partilhado por todos os
// pontos de saída (navegação interna via botões, links, FAB, logo, menu
// lateral/inferior, recuar do browser). "Continuar a editar" é a ação
// segura/por defeito; não existe botão "Guardar" aqui.
export default function UnsavedChangesDialog({ open, onOpenChange, onConfirm, onCancel }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={UNSAVED_CHANGES.dialog}>
        <AlertDialogHeader>
          <AlertDialogTitle>Existem alterações por guardar</AlertDialogTitle>
          <AlertDialogDescription>
            Se sair agora, as alterações efetuadas serão perdidas. Pretende continuar?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={UNSAVED_CHANGES.cancel} onClick={onCancel}>
            Continuar a editar
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={UNSAVED_CHANGES.confirm}
            onClick={onConfirm}
            className="bg-[#B91C1C] hover:bg-[#991B1B] text-white"
          >
            Sair sem guardar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
